'use client'

import { Trans, useTranslation } from 'react-i18next'

import type { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'

import { useClient } from '~/lib/hooks/use-is-client'

import {
  AdvancedFeature,
  ImageJPGBackground,
  ImagePNGIllustration
} from './components/AuthComponent'

const LayoutLoginRegister: FCC = ({ children }) => {
  const { t } = useTranslation()
  const { isClient } = useClient()

  return (
    <div className="tablet:min-h-screen tablet:grid-cols-2 grid overflow-hidden">
      <div className="h-full">{children}</div>
      <div className="tablet:h-full relative h-[870px] overflow-hidden bg-gray-100">
        <ImageJPGBackground
          largeDesktopImageName="background_largeDesktop"
          desktopImageName="background_desktop"
          tabletImageName="background_tablet"
          mobileImageName="background_mobile"
        />
        <ImagePNGIllustration
          desktopImageName="illustration"
          tabletImageName="illustration_tablet"
          mobileImageName="illustration_mobile"
        />

        {isClient ? (
          <div className="tablet:left-6 tablet:pl-0 tablet:pr-6 tablet:pt-10 desktop:left-16 desktop:w-[501px] desktop:px-0 desktop:pt-16 largeDesktop:left-[145px] absolute z-10 px-4 pt-8">
            <TypographyText className="tablet:mb-8 tablet:text-3xl desktop:text-4xl mb-6 text-2xl font-semibold text-gray-900">
              <Trans i18nKey={'auth:transformTheWayYouHire'} />
            </TypographyText>
            <ul className="">
              <AdvancedFeature index={0} content={`${t('auth:seamlessHiringFlow')}`} />
              <AdvancedFeature index={1} content={`${t('auth:advancedTalentSearch')}`} />
              <AdvancedFeature index={2} content={`${t('auth:unifiedRecruitmentPlatform')}`} />
              <AdvancedFeature index={3} content={`${t('auth:hiringPerformanceDashboard')}`} />
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default LayoutLoginRegister
